module.exports = __webpack_public_path__ + "static/media/xegotech-logo.fd26e9a8.png";